import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { LoginComponent } from './Components/login/login.component';

import { SignupComponent } from './Components/signup/signup.component';
import {EmployerLoginComponent} from "./Components/employer-login/employer-login.component";
import {LoanAppSignUpComponent} from "./Components/loan-app-sign-up/loan-app-sign-up.component";
import {BenefAdvancedSearchComponent} from "./Components/benef-advanced-search/benef-advanced-search.component";
import {
  BenefAdvancedSearchProgressComponent
} from "./Components/benef-advanced-search-progress/benef-advanced-search-progress.component";
import {PasswordresetComponent} from "./Components/passwordreset/passwordreset.component";

const routes: Routes = [
    {
        path: 'login',
        component: LoginComponent
    },
    {
      path: 'employer-login',
      component: EmployerLoginComponent
    },
    {
        path: 'signup',
        component: SignupComponent
    },
    // {
    //     path: 'signup-2',
    //     component: Register2Component
    // },
    {
        path: 'reset-password',
        component: PasswordresetComponent
    },
    // {
    //     path: 'recoverpwd-2',
    //     component: Recoverpwd2Component
    // },
    // {
    //     path: 'login-2',
    //     component: Login2Component
    // },
    {
        path: 'benef-advanced-search',
        component: BenefAdvancedSearchComponent
    },
    {
        path: 'benef-advanced-search-progress',
        component: BenefAdvancedSearchProgressComponent
    },
    {
      path: 'loan-app-signup/:index_no',
      component: LoanAppSignUpComponent
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AuthRoutingModule { }
